import { DraftsRounded } from '@material-ui/icons';
import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function pleitoVeiculo(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@pleitoveiculo/FIND_PLEITOVEICULO':
      case '@pleitoveiculo/UPDATE_PLEITOVEICULO':
      case '@pleitoveiculo/DELETE_PLEITOVEICULO':
      case '@pleitoveiculo/STORE_PLEITOVEICULO':
      case '@pleitoveiculo/PLEITOVEICULO_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@pleitoveiculo/SUCCESS_REMOVE':
      case '@pleitoveiculo/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@pleitoveiculo/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.pleitoveiculos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@pleitoveiculo/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.pleitoveiculos;
        break;
      }

      case '@pleitoveiculo/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
